// Loader
// Utilities
import * as React from "react";
// Store loader context
export const StoreLoaderContext = React.createContext(null);
